import {ParamCodeExporter} from '../Param';
import {NodePathParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/NodePath';

export class ParamNodePathCodeExporter extends ParamCodeExporter<NodePathParam> {
	// as_code_default_value_string() {
	// 	return `'${this._param.defaultValue()}'`;
	// }

	override add_main() {
		let val = this._param.value.path();
		val = val.replace(/'/g, "\\'");
		const line = this.prefix() + `.set('${val}')`;
		this._lines.push(line);
	}

	override HTMLSnippet() {
		const id = this._HTMLId(this._param);
		const label = `<label for='${id}'>${id}</label>`;
		const numberInput = `<input type='text' id='${id}' name='${id}' value=${this._param.value.path()}></input>`;
		return `${label}
${numberInput}`;
	}
	override JSSnippet() {
		const id = this._HTMLId(this._param);
		return `document.getElementById('${id}').addEventListener('input', function(event){
	scene.node('${this._param.node.path()}').p.${this._param.name()}.set(event.target.value);
})`;
	}
}
